import { DataAccess } from "../dataaccess/data.access";
import { Timeout } from "../decorators/timeout.decorator";
import { Cache, Invalidate } from "../decorators/cache.decorator";
import { SearchCriteria } from "../pojo/SearchCriteria";
import StepType = SearchCriteria.StepType;

export interface EventPreferences {
    panelId: number;
    group: Group[];
}

export interface Group {
    item: Item[];
    typeId: (typeof StepType.Location)["Features" | "Partitions" | "Spaces"] | typeof StepType.Resource.Resources;
    queryId: number;
}

//itemTypeId
export interface Item {
    itemId: number;
    itemName: string;
    quantity?: number;
    quantityMax?: number;
}

export class EventPreferencesService {
    @Timeout
    @Cache({ immutable: true, targetName: "EventPreferencesService" })
    public static getPreferences(eventId: number) {
        return DataAccess.get<{ pref: { panel?: EventPreferences[] } }>(
            DataAccess.injectCaller(
                "/event/detail/pref.json?" + DataAccess.composeParam("event_id", eventId, true),
                "EventPreferencesService.getPreferences",
            ),
        ).then(function (data) {
            return data.pref;
        });
    }

    @Invalidate({ serviceName: "EventPreferencesService" })
    @Timeout
    public static putPreferences(
        eventId: number,
        panelId: number,
        typeId: number,
        queryId: number,
        items: Pick<Item, "itemId" | "quantity">[],
    ) {
        return DataAccess.put(
            DataAccess.injectCaller(
                "/event/detail/pref.json?" +
                    DataAccess.composeParam("event_id", eventId, true) +
                    DataAccess.composeParam("panelId", panelId) +
                    DataAccess.composeParam("typeId", typeId) +
                    DataAccess.composeParam("query_id", queryId),
                "EventPreferencesService.putPreferences",
            ),
            {
                data: { item: items },
            },
        );
    }

    @Invalidate({ serviceName: "EventPreferencesService" })
    @Timeout
    public static deletePreferences(eventId: number, panelId: number, typeId: number, queryId: number) {
        return DataAccess.delete(
            DataAccess.injectCaller(
                "/event/detail/pref.json?" +
                    DataAccess.composeParam("event_id", eventId, true) +
                    DataAccess.composeParam("panelId", panelId) +
                    DataAccess.composeParam("typeId", typeId) +
                    DataAccess.composeParam("query_id", queryId),
                "EvdPrefDao.delete",
            ),
        );
    }
}
